import { Component, input } from '@angular/core';

import {
  FeatureComponent,
  GeoJSONSourceComponent,
  LayerComponent,
} from 'ngx-mapbox-gl';

@Component({
  selector: 'app-radar-distance-circles',
  templateUrl: './radar-distance-circles.component.html',
  imports: [GeoJSONSourceComponent, FeatureComponent, LayerComponent],
})
export class RadarDistanceCirclesComponent {
  zoomLevel = input<number>(0);
  geometry = input<any>();
  labels = input<any[]>([]);
  circlePaint = input<any>();
  styleName = input<string>();

  get legacyCircleGeometry(): any[] {
    const geometry = this.geometry();

    if (Array.isArray(geometry)) {
      return geometry;
    }

    if (geometry?.features && Array.isArray(geometry.features)) {
      return geometry.features
        .filter(feature => feature?.properties?.type === 'outline')
        .map(feature => feature.geometry);
    }

    return [];
  }

  get circleLabels(): any[] {
    const geometry = this.geometry();

    if (geometry?.features && Array.isArray(geometry.features)) {
      return geometry.features
        .filter(feature => feature?.properties?.type === 'label')
        .map(feature => ({
          geometry: feature.geometry,
          text: feature.properties?.label,
        }));
    }

    return this.labels();
  }

  shouldRenderCircles(): boolean {
    return this.zoomLevel() > 6 && this.legacyCircleGeometry.length > 0;
  }

  getTextHaloColor(): string {
    return this.styleName() === 'street' ? 'white' : 'black';
  }
}
